/**
 * 일일 리포트 상세 페이지
 */

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getReportDetail, ReportDetail as ReportDetailType } from '../services/reportApi';
import './ReportDetail.css';
import AccountSummaryCard from '../components/reports/AccountSummaryCard';
import PositionsTable from '../components/reports/PositionsTable';
import TradesTable from '../components/reports/TradesTable';

const ReportDetail: React.FC = () => {
  const { date } = useParams<{ date: string }>();
  const [report, setReport] = useState<ReportDetailType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (date) {
      loadReport(date);
    }
  }, [date]);

  const loadReport = async (reportDate: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getReportDetail(reportDate);
      setReport(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : '리포트 조회 실패');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="report-detail-container">
        <div className="loading">리포트 로딩 중...</div>
      </div>
    );
  }

  if (error || !report) {
    return (
      <div className="report-detail-container">
        <Link to="/reports" className="back-link">
          ← 목록으로
        </Link>
        <div className="error">
          <p>{error || '리포트를 찾을 수 없습니다'}</p>
          <Link to="/reports">목록으로 돌아가기</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="report-detail-container">
      <div className="report-header">
        <Link to="/reports" className="back-link">
          ← 목록으로
        </Link>
        <h1>일일 리포트 ({report.date})</h1>
      </div>
      <section className="report-detail-scope">
        <strong>{report.scope === 'live' ? 'US Live pilot' : 'US Paper archive'}</strong>
        <span>
          {report.scope === 'live'
            ? 'Toss US live_pilot 전환 이후 리포트입니다. 과거 paper 성과와 합산하지 않습니다.'
            : 'Alpaca paper 운영 리포트입니다. 현재 live_pilot 성과로 해석하지 않습니다.'}
        </span>
      </section>

      <AccountSummaryCard account={report.account} />
      <PositionsTable positions={report.positions} />
      <TradesTable trades={report.trades} />
    </div>
  );
};

export default ReportDetail;
